import { Share2, Palette, Globe, Store, ArrowUpRight } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";
import { SERVICES } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

const ICONS = [Share2, Palette, Globe, Store];

export const Services = () => (
  <section id="cosa" data-testid="services-section" className="bg-white py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <Kicker>Cosa facciamo</Kicker>
        <h2 className="mt-5 max-w-3xl font-display text-4xl font-black leading-[1.0] tracking-tight text-navy sm:text-6xl">
          MARKETING A 360°. <span className="text-brand-gradient">SOCIAL-FIRST.</span>
        </h2>
        <div className="mt-8 max-w-2xl space-y-4 text-base leading-relaxed text-slate-600 sm:text-lg">
          <p>
            Ogni progetto parte da una domanda: <span className="font-semibold text-navy">come possiamo rendere questo brand più visibile, riconoscibile e competitivo?</span>
          </p>
          <p>
            Per noi i social sono il punto di partenza della strategia: lo spazio fondamentale per attirare l'attenzione, raccontare un'attività e creare interesse. Ma il marketing non si esaurisce in un post o in un video: integriamo contenuti, identità visiva, strumenti digitali e comunicazione offline in un'unica direzione strategica.
          </p>
          <p className="font-semibold text-navy">Partiamo dai social. Poi costruiamo tutto ciò che serve al brand.</p>
        </div>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={s.number} delay={i * 0.08} className="h-full">
              <article
                data-testid={`service-card-${s.number}`}
                className="group relative flex h-full flex-col border border-slate-200 bg-white p-7 transition-[transform,box-shadow,border-color] duration-400 hover:-translate-y-1.5 hover:border-transparent hover:shadow-[0_24px_60px_-24px_rgba(37,99,235,0.35)]"
              >
                <span className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-brand-gradient transition-transform duration-500 group-hover:scale-x-100" aria-hidden="true" />
                <div className="flex items-start justify-between">
                  <span className="font-mono text-sm tracking-[0.25em] text-brand-blue">{s.number}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 text-navy transition-colors duration-300 group-hover:border-brand-blue group-hover:text-brand-blue">
                    <Icon className="h-5 w-5" strokeWidth={1.8} />
                  </span>
                </div>
                <h3 className="mt-8 font-display text-xl font-extrabold tracking-tight text-navy">{s.title}</h3>
                <ul className="mt-5 flex-1 space-y-2">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-center gap-2.5 text-sm text-slate-600">
                      <span className="h-1 w-1 shrink-0 rounded-full bg-brand-gradient" aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
                <button
                  type="button"
                  data-testid={`service-cta-${s.number}`}
                  onClick={() => scrollToSection("contatti")}
                  className="mt-7 inline-flex items-center gap-2 font-display text-xs font-bold tracking-[0.18em] text-navy/40 transition-colors duration-300 group-hover:text-brand-blue"
                >
                  INIZIA DA QUI
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </button>
              </article>
            </Reveal>
          );
        })}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-10 max-w-2xl text-sm italic text-slate-500">
          Non è necessario acquistare tutti i servizi: ogni progetto parte da ciò che serve davvero al tuo brand.
        </p>
      </Reveal>
    </div>
  </section>
);
